const defaultSports = "nfl"

const sportsCode = (new URL(window.location)).pathname.split('/')[1] === "" ? defaultSports : (new URL(window.location)).pathname.split('/')[1];

const Standings = () => {

    const { useState, useEffect } = React
    const [navHeight, setNavHeight] = useState(0);
    const [sports, setSports] = useState(sportsCode?.toLowerCase())
    const [standing, setStanding] = useState([])
    const [buttonClickInHome, setButtonClickInHome] = useState(true)

    const urls = [
        `/${sportsCode}/GetStanding`
    ];

    const fetchData = async (url) => {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Fetch failed with status: ${response.status}`);
        }
        return response.json();
    };

    const PormiseAll = async () => {
        try {
            // Use Promise.all to fetch the data asynchronously
            const [standingData] = await Promise.all(
                urls.map(url => fetchData(url))
            );

            /** standing */
            const groupedByDivision = standingData.reduce((result, item) => {
                const { division, total_ties } = item;
                result[division] = [...(result[division] || []), item];
                return result;
            }, {});


            Object.values(groupedByDivision).forEach(group => {
                group.forEach(item => {
                    item.show = item.total_ties > 0;
                });
            });

            setStanding(Object.values(groupedByDivision))



        } catch (error) {
            // Handle errors here
            console.error('Error:', error);
        }
    };

    const handleButtonClickInHome = () => {
        // Update the state to notify the App component

        setButtonClickInHome(!buttonClickInHome);
    };

    useEffect(() => {


        const gamelistDiv = document.getElementById("gamelist");
        const gamelistDivContainer = document.getElementById("container_gamelist");

        const sc = sportsCode?.toLowerCase();

        if (sc === "nfl" || sc === "mlb") {

            if (gamelistDiv) {
                gamelistDiv.classList.add("d-none");
            }

            if (gamelistDivContainer) {
                gamelistDivContainer.classList.add("d-none");
            }

            PormiseAll();
        }
        else {


            if (gamelistDiv) {
                gamelistDiv.classList.remove("d-none");
            }

            if (gamelistDivContainer) {
                gamelistDivContainer.classList.remove("d-none");
            }
        }

        const nav = document.querySelector('.navbar');
        if (nav) {
            const height = nav.offsetHeight;
            setNavHeight(height);
        }

    }, [])

    return (
        <div className={`container-fluid px-2 py-2 px-lg-0 ${sports === "nfl" || sports === "mlb" ? "" : "d-none"}`} style={{ marginTop: "40px", marginTop: `${navHeight}px` }}>
            <div className="row">   
                <div className="col-12 px-0">
                    <div className="">
                        <div className="d-flex flex-row gap-1">
                            {standing?.length > 0 ? (
                                <ScoreboardCarousel data={standing} /*onButtonClick={handleButtonClickInHome}*/ />
                            ) : (
                                <SkeletonComponent type={'scoreboard'} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


}

const root = ReactDOM.createRoot(document.getElementById('home-standings'));
root.render(
    <Standings />
);


const ScoreboardCarousel = ({ data, onButtonClick }) => {

    const { useState, useEffect } = React

    const [buttonClickInScoreboard, setButtonClickInScoreboard] = useState(false)

    const [maxVisibleItems, setMaxVisibleItems] = useState(7);
    const [isMobile, setIsMobile] = useState(false);
    const [showScoreboard, setShowScoreboard] = useState(true);
    const [winWidth, setWinWidth] = useState(0);
    const updateMaxVisibleItems = () => {

        if (window.innerWidth <= 390) {
            setMaxVisibleItems(1);
        } else if (window.innerWidth <= 768) {
            setMaxVisibleItems(2);
        } else if (window.innerWidth <= 1024) {
            setMaxVisibleItems(3);
        } else if (window.innerWidth <= 1280) {
            setMaxVisibleItems(4);
        } else if (window.innerWidth <= 1536) {
            setMaxVisibleItems(5);
        } else if (window.innerWidth <= 1920) {
            setMaxVisibleItems(6);
        }
        else {
            setMaxVisibleItems(8);
        }
    };

    const itemWidth = sportsCode?.toLowerCase() === "nfl" ? 17 : 17;
    const scoreboardDataLength = data.length;

    //const containerWidth = `${maxVisibleItems * itemWidth}rem`

    let containerWidth;

    if (isMobile) {
        containerWidth = '100%'; // Set to full width for mobile
    } else {
        containerWidth = `${maxVisibleItems * itemWidth}rem`;
    }

    const [currentSlide, setCurrentSlide] = useState(0);

    const prevSlide = () => {
        setCurrentSlide((prevSlide) =>
            prevSlide <= 0 ? scoreboardDataLength - maxVisibleItems : prevSlide - maxVisibleItems
        );
    };

    const slideClick = (isNext) => {
        setCurrentSlide((index) => {
            let nextSlideIndex = isNext ? index + maxVisibleItems : index - maxVisibleItems;

            let resultLength = 0;

            if (nextSlideIndex < 1)
                nextSlideIndex = 0;

            resultLength = scoreboardDataLength - nextSlideIndex

            if (resultLength < maxVisibleItems) {
                nextSlideIndex = scoreboardDataLength - maxVisibleItems
            }

            return nextSlideIndex;
        });
    };

    const isPrevButtonDisabled = currentSlide <= 0;
    const isNextButtonDisabled = currentSlide >= scoreboardDataLength - maxVisibleItems;

    const toggleScoreboard = () => {
        setShowScoreboard(!showScoreboard);

        const heroContainers = document.querySelectorAll('.hero-container');
        heroContainers.forEach(container => {
            container.style.display = !showScoreboard ? 'none' : 'block'; 
        });

    };

    useEffect(() => {

        updateMaxVisibleItems();
        window.addEventListener('resize', updateMaxVisibleItems);

        setWinWidth(window.innerWidth);

        // Detect mobile screen size initially
        if (window.innerWidth <= 768) {
            setIsMobile(true)
            setShowScoreboard(false)
            setMaxVisibleItems(2)

        }
        else if (window.innerWidth <= 1024 && window.innerWidth > 768) {
            setMaxVisibleItems(3)
        }

        else if (window.innerWidth <= 1584 && window.innerWidth > 1024) {
            setMaxVisibleItems(4)
        }
        else if (window.innerWidth <= 1820 && window.innerWidth > 1584) {
            setMaxVisibleItems(5)
        }
        else {
            setMaxVisibleItems(6)
        }
        return () => {
            window.removeEventListener('resize', updateMaxVisibleItems);
        };
    }, []);

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsDropdownOpen((prevState) => !prevState);
    };

    return (
        <div className="w-100">
            {isMobile && (
                <button
                    onClick={toggleScoreboard}
                    className="btn-light hamburger-button btn fs-5 fw-bold bg-light py-1 text-blue-nv1">
                    {showScoreboard ? <span>CLOSE</span> : <span>STANDINGS</span>}
                </button>
            )}
            {showScoreboard && (
                <div className="scoreboard-carousel d-flex align-items-center">
                    <div
                        role="button"
                        className="card bg-light standing-card link-dark d-flex align-items-center border-0" onClick={() => slideClick(false)} // make the arrow container a flexbox too
                    >
                        <div className={`card-body d-flex justify-content-center align-items-center w-100 ${isMobile || (isPrevButtonDisabled && isNextButtonDisabled) ? "d-none" : isPrevButtonDisabled ? "disabled" : ""}`} onClick={() => slideClick(true)}> {/* center the arrow both horizontally and vertically */}
                            <i className="fa-solid fa-arrow-left text-lg text-dark"></i>
                        </div>
                    </div>

                    <div className="scoreboard" style={{ width: containerWidth }}>
                        <div
                            className={`scoreboard-items ${isMobile ? 'row d-flex flex-column flex-sm-row gap-0 pt-2' : ''} transition-transform cubic-bezier(0.68, -0.55, 0.27, 1.55) duration-1000`}
                            style={{
                                transform: `translateX(-${currentSlide * itemWidth}rem)`,
                                width: `${scoreboardDataLength * itemWidth}rem`,
                            }}
                        >
                            {data?.map((d, index) => (
                                <div
                                    key={'division' + index}
                                    className={`${window?.innerWidth <= 768 && 'col-12 col-sm-6'} standings card bg-white standing-card ${index !== (currentSlide + maxVisibleItems - 1) ? 'border-r border-gray-300' : ''}`}
                                    style={{ width: `${window?.innerWidth <= 768 ? "" :  itemWidth + 'rem'  } `}}
                                >
                                    <div className="card-body px-1 p-0 mr-5">
                                        <div className="row text-dark">
                                            <div className={`${d[0].show ? "col-4" : "col-6"} text-start fs-6 fw-bold`}>{d[0]?.division}</div>
                                            <div className="col-3 text-center fs-6 fw-bold">W</div>
                                            <div className="col-3 text-center fs-6 fw-bold">L</div>
                                            <div className={`col-2 text-center fs-6 fw-bold ${!d[0].show && "d-none"}`}>T</div>
                                        </div>
                                        {d?.map((item, itm_idx) => (
                                            <div className="row" key={`${name}_${item?.team_id}_${itm_idx}`}>
                                                <div className={`${d[0].show ? "col-4" : "col-6"} d-flex text-start align-items-center`}>
                                                    <img className="img-fluid" style={{ maxWidth: '20px', height: 'auto' }} src={`/_ie/_${sportsCode}_teams_xs/${item?.team_id}.webp`} alt="" />
                                                    <a className="team-name text-decoration-none ms-2 text-secondary text-sm" href={`/${sportsCode}/Team?id=${item?.team_id}`}>{item?.market}</a>
                                                </div>
                                                <div className="col-3 text-center text-sm">{item?.total_wins}</div>
                                                <div className="col-3 text-center text-sm">{item?.total_losses}</div>
                                                <div className={`col-2 text-center text-sm ${!d[0].show && "d-none"}`}>{item?.total_ties}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div
                        role="button"
                        className="card bg-light standing-card link-dark d-flex align-items-center" onClick={() => slideClick(true)} // make the arrow container a flexbox too
                    >
                        <div className={`card-body d-flex justify-content-center align-items-center w-100 ${isMobile || (isPrevButtonDisabled && isNextButtonDisabled)  ? "d-none" : isNextButtonDisabled ? "disabled" : ""}`} onClick={() => slideClick(true)}> {/* center the arrow both horizontally and vertically */}
                            <i className="fa-solid fa-arrow-right text-lg text-dark"></i>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

};

const SkeletonComponent = ({ type }) => {

    if (type === "scoreboard") {

        return (
            <div className="d-flex" style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <h4>Loading...</h4>
            </div>
        );

    }
    else {
        return (
            <div className="inline-block min-w-full py-8 align-middle sm:px-6 lg:px-8">
                <div role="status" className="max-w-lg animate-pulse">
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        )
    }
}

